import { guildApi } from '@/lib/guildApi'
import { OFFICIAL_INVITE } from '@/lib/links'
import { useAppStore } from '@/store/app'
import { useGuildStore } from '@/store/guilds'

/**
 * Открыть официальный сервер Кличата. Кто уже там — попадает сразу в сервер (в последний канал
 * или в тот, куда ведёт приглашение), остальные — на страницу приглашения с кнопкой «Принять».
 * Id сервера в клиент не зашит: его знает бессрочное приглашение, и так же работает любое окружение.
 */
export async function openOfficialServer(): Promise<void> {
  const app = useAppStore.getState()
  try {
    const inv = await guildApi.invite(OFFICIAL_INVITE)
    if (useGuildStore.getState().guilds[inv.guild.id]) {
      app.openGuild(inv.guild.id, app.lastChannel[inv.guild.id] ?? inv.channel.id)
      return
    }
  } catch {
    // приглашение не нашлось — страница приглашения сама скажет, что с ним
  }
  app.setPendingInvite(OFFICIAL_INVITE)
}
